module.exports = __webpack_public_path__ + "static/img/review.bdcbd8ab.png";